module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/rotate_hover_VA.c6145858.svg";